import React, { FC } from 'react';

import { StyledPopupMain } from './popupMain.styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PopupMain: FC<{ children?: any; className?: string }> = ({ children, className }) => {
  return (
    <StyledPopupMain data-component-name="a-shop-PopupMain" className={className}>
      {children}
    </StyledPopupMain>
  );
};

export default PopupMain;
